import React from "react";
import {CatalogService} from "../../../service/catalog/CatalogService";
import PresvalDropDown from "../PresvalDropDownView";


export default class InstrumentDropDownContainer extends React.Component {
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();

        this.getCatalogInstrument = this.getCatalogInstrument.bind(this);

        this.state = {
            catInstrumentCatalog: this.getCatalogInstrument(),
        };
    }

    getCatalogInstrument() {
        this.catalogService.getCatalogInstrument().then(
            catalogInstrument => {
                let instrumentList = [];
                let instrumentMap = [];

                catalogInstrument.map(instrument => {
                    if (!instrumentMap.includes(instrument.emisoraSerieCupon)) {
                        instrumentList.push(instrument);
                    }
                    instrumentMap.push(instrument.emisoraSerieCupon)
                    return '';
                });

                this.setState({
                    catInstrumentCatalog: instrumentList,
                });
                this.props.loading(false);
            }
        );
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catInstrumentCatalog}
            save={this.props.save}
            value={this.props.value}
            placeholder={this.props.placeholder}
            tabIndex={this.props.tabIndex}
        />
    }
};